import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const Niveau1Page = lazy(() => import('../pages/niveau-1/page'));
const Niveau2Page = lazy(() => import('../pages/niveau-2/page'));
const Niveau3Page = lazy(() => import('../pages/niveau-3/page'));
const Niveau4Page = lazy(() => import('../pages/niveau-4/page'));
const Niveau5Page = lazy(() => import('../pages/niveau-5/page'));
const Niveau6Page = lazy(() => import('../pages/niveau-6/page'));
const MentionsLegalesPage = lazy(() => import('../pages/legal/mentions-legales/page'));
const CGVPage = lazy(() => import('../pages/legal/cgv/page'));
const ConfidentialitePage = lazy(() => import('../pages/legal/confidentialite/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/niveau-1', element: <Niveau1Page /> },
  { path: '/niveau-2', element: <Niveau2Page /> },
  { path: '/niveau-3', element: <Niveau3Page /> },
  { path: '/niveau-4', element: <Niveau4Page /> },
  { path: '/niveau-5', element: <Niveau5Page /> },
  { path: '/niveau-6', element: <Niveau6Page /> },
  { path: '/mentions-legales', element: <MentionsLegalesPage /> },
  { path: '/cgv', element: <CGVPage /> },
  { path: '/confidentialite', element: <ConfidentialitePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
